module.exports = __webpack_public_path__ + "media/images/emoticons/cancer-b727d1c9615205da5742dd82a4833e7e.gif";